import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-75 mb-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: null
}, "Select Reason", -1 /* HOISTED */)
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = ["name", "value", "placeholder", "disabled", "maxlength"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("select", {
        class: "form-select",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pendingReason) = $event))
      }, [
        _hoisted_2,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patientPendingReasons, ([key, value]) => {
          return (_openBlock(), _createElementBlock("option", {
            value: value.value,
            key: key
          }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_3))
        }), 128 /* KEYED_FRAGMENT */))
      ], 512 /* NEED_PATCH */), [
        [_vModelSelect, _ctx.pendingReason]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("textarea", {
        class: _normalizeClass(`form-control ${_ctx.classList.textarea}`),
        rows: "4",
        name: _ctx.inputName,
        value: _ctx.result,
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        maxlength: _ctx.maxLength
      }, null, 10 /* CLASS, PROPS */, _hoisted_5)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}